import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCategoryFilters,
  selectDateFilters,
  selectExistParams,
  selectLocationFilters,
} from '../../store/entities/selectors';
import Filter from '../Filter';
import { getAudioList } from '../../store/system/actions';
import { makeStyles } from '@material-ui/core/styles';
import { deviceMaxWidth, deviceMinWidth } from '../../constants';
import clsx from 'clsx';
import { paramsToDeleteHelper } from '../../utils/helpers';
import { useState } from 'react';

export interface IOptionsItem {
  value: string;
  text: string;
  selected: boolean;
}

export interface IFilter {
  name: string;
  parent: string | null;
  title: string;
  options: IOptionsItem[];
}

export interface IOnClick {
  onClickFilter?: (data: { [name: string]: string }) => void;
}

export default function FilterContainer() {
  const styles = useStyles();
  const dispatch = useDispatch();
  const categoryFilters = useSelector(selectCategoryFilters);
  const dateFilters = useSelector(selectDateFilters);
  const locationFilters = useSelector(selectLocationFilters);
  const existParams = useSelector(selectExistParams);
  {/*поиск*/}
  const [search, setSearch] = useState('');

  const onClickFilter = (params: { [name: string]: string }) => {
    paramsToDeleteHelper(params, existParams);
    const data = {
      ...existParams,
      ...params,
    };
    dispatch(getAudioList(data));
  };

  return (
    <div className={styles.filterContainer}>
      <div className={clsx(styles.filterColumn, styles.firstRow)}>

        {/*поиск*/}
        <div className={styles.filterContainer}>
          <input
            id={'asdas'}
            name={'asdasd'}
            type={'text'}
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            className="floating__input"
          />
          <div className={styles.button} onClick={() => onClickFilter({ 'q': search})}>Поиск</div>
        </div>
        {/*поиск*/}


        {categoryFilters?.map((filter: IFilter) => (
          <Filter
            {...filter}
            key={`${filter?.name}-${filter?.title}`}
            onClickFilter={onClickFilter}
          />
        ))}
      </div>
      <div className={clsx(styles.filterColumn, styles.secondRow)}>
        {dateFilters?.map((filter: IFilter) => (
          <Filter
            {...filter}
            key={`${filter?.name}-${filter?.title}`}
            onClickFilter={onClickFilter}
          />
        ))}
      </div>
      <div className={clsx(styles.filterColumn, styles.thirdRow)}>
        {locationFilters?.map((filter: IFilter) => (
          <Filter
            {...filter}
            key={`${filter?.name}-${filter?.title}`}
            onClickFilter={onClickFilter}
          />
        ))}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  filterContainer: {
    display: 'flex',

    [deviceMaxWidth.size500]: {
      flexDirection: 'column',
    },

    [deviceMinWidth.size361]: {
      [deviceMaxWidth.size1024]: {
        flexDirection: 'column',
      },
    },
    [deviceMaxWidth.size500]: {
      width: '100%',
    },
    [deviceMinWidth.size501]: {
      [deviceMaxWidth.size600]: {
        width: '94%',
      },
    },
  },
  filterColumn: {
    marginLeft: 14,

    [deviceMaxWidth.size600]: {
      marginLeft: 0,
    },
  },
  button: {
    width: 135,
    padding: `10px 20px`,
    border: `1px solid #D0690D`,
    fontSize: 14,
    borderRadius: 5,
    color: '#603004',
    cursor: 'pointer',
    textAlign: 'center',
    '&:hover': {
      color: 'white',
      backgroundColor: '#D0690D',
    },
  },

  firstRow: {
    width: 280,
    [deviceMinWidth.size1201]: {
      [deviceMaxWidth.size1300]: {
        width: 220,
      },
    },
    [deviceMinWidth.size1025]: {
      [deviceMaxWidth.size1200]: {
        width: 200,
      },
    },
    [deviceMinWidth.size769]: {
      [deviceMaxWidth.size1024]: {
        width: 280,
      },
    },
    [deviceMinWidth.size601]: {
      [deviceMaxWidth.size768]: {
        width: 200,
      },
    },
    [deviceMaxWidth.size600]: {
      width: '100%',
    },
  },

  secondRow: {
    width: 180,
    [deviceMinWidth.size1201]: {
      [deviceMaxWidth.size1300]: {
        width: 150,
      },
    },
    [deviceMinWidth.size1025]: {
      [deviceMaxWidth.size1200]: {
        width: 120,
      },
    },
    [deviceMinWidth.size769]: {
      [deviceMaxWidth.size1024]: {
        width: 280,
      },
    },
    [deviceMinWidth.size601]: {
      [deviceMaxWidth.size768]: {
        width: 200,
      },
    },
    [deviceMaxWidth.size600]: {
      width: '100%',
    },
  },

  thirdRow: {
    width: 200,
    [deviceMinWidth.size1201]: {
      [deviceMaxWidth.size1300]: {
        width: 180,
      },
    },
    [deviceMinWidth.size1025]: {
      [deviceMaxWidth.size1200]: {
        width: 150,
      },
    },
    [deviceMinWidth.size769]: {
      [deviceMaxWidth.size1024]: {
        width: 280,
      },
    },
    [deviceMinWidth.size601]: {
      [deviceMaxWidth.size768]: {
        width: 200,
      },
    },
    [deviceMaxWidth.size600]: {
      width: '100%',
    },
  },
}));
